<!-- =========================================================================================
  File Name: SessionViewDetails.vue
  Description: Session View Details List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-list">
    <!--<div class="header-custome">
      <h2>Page View Report</h2>
    </div>-->
    <div class="vx-card p-6">
      <div class="vx-row w-full">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            <b>Session Name:&nbsp;</b>
          </label>
          <label>{{ SessionName }}</label>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4" style="text-align: center">
          <label><b>Total No. of Participants:&nbsp;</b></label>
          <label>{{ totalParticipants }}</label>
        </div>
      </div>
      <div class="flex flex-wrap items-center mt-4">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  pageViewUserData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : pageViewUserData.length
                }}
                of {{ pageViewUserData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="allMembersList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module

import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import SessionViewCellRendererStatus from "./cell-renderer/SessionViewCellRendererStatus.vue";
import SessionViewCellRendererTypeStatus from "./cell-renderer/SessionViewCellRendererTypeStatus.vue";
import moment from "moment-timezone";
import con from "@/firebase/firebaseInit.ts";

//console.log(db);
//const event_collectionName = 'sayek-dev';

var vm;
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  data() {
    return {
      allAttendeeList: [],
      participantsList: [],
      allMembersList: [],
      totalParticipants: 0,
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      sessionName: "",
      actionType: "",
      pageView_UserData: [],
      tableStatus: null,
      columnDefs: [
        {
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 200,
        },
        {
          headerName: "Type",
          field: "Type",
          filter: true,
          width: 150,
          cellRendererFramework: "SessionViewCellRendererTypeStatus",
        },
        {
          headerName: "Company",
          field: "Company",
          filter: true,
          width: 150,
        },
        {
          headerName: "Title",
          field: "Designation",
          filter: true,
          width: 200,
        },
        {
          headerName: "Status",
          field: "Status",
          filter: false,
          width: 150,
          cellRendererFramework: "SessionViewCellRendererStatus",
        },
        {
          headerName: "Joined Time",
          field: "JoinTime",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: false,
          width: 150,
        },
        {
          headerName: "Leave Time",
          field: "LeaveTime",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: false,
          width: 150,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        SessionViewCellRendererStatus,
        SessionViewCellRendererTypeStatus,
      },
    };
  },
  computed: {
    SessionName() {
      return vm.sessionName;
    },
    ActionType() {
      return vm.actionType;
    },
    pageViewUserData() {
      return this.allMembersList;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  components: {
    AgGridVue,
    vSelect,
    quillEditor,
    //CellRenderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    SessionViewCellRendererStatus,
    SessionViewCellRendererTypeStatus,
  },
  methods: {
    fetchParticipantsBySessionId(sessionId) {
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      var hostAttendeeList = [];
      var speakerAttendeeList = [];
            con.eventDB
        .collection(cn)
        .doc("SessionList")
        .collection("Sessions")
        .doc(sessionId)
        .get()
        .then((doc) => {
             doc.data().MappedHosts.map((row) => {
               hostAttendeeList.push(row.AttendeeId);
             });
              doc.data().MappedSpeakers.map((row) => {
               speakerAttendeeList.push(row.AttendeeId);
             });

          });

          var allParticipantsList =[];
      con.eventDB
        .collection(cn)
        .doc("SessionList")
        .collection("Sessions")
        .doc(sessionId)
        .collection("Participances")
        .get()
        .then((querySnapshot) => {
          this.totalParticipants = querySnapshot.size;
          querySnapshot.forEach((doc) => {
                allParticipantsList.push(doc.data().AttendeeId);
            this.allAttendeeList.map((row1) => {
              if(hostAttendeeList.includes(row1.AttendeeId) == true){
                    if (row1.AttendeeId === doc.data().AttendeeId) {
                       row1.Type = "Host";
                       row1.Status = "Joined";
                       row1.JoinTime = doc.data().JoinTime;
                       row1.LeaveTime = doc.data().LeaveTime;
                    }
                }else if(speakerAttendeeList.includes(row1.AttendeeId) == true && hostAttendeeList.includes(row1.AttendeeId) == false){
                    if (row1.AttendeeId === doc.data().AttendeeId) {
                       row1.Type = "Speaker";
                       row1.Status = "Joined";
                       row1.JoinTime = doc.data().JoinTime;
                       row1.LeaveTime = doc.data().LeaveTime;
                    }
                }else{
                  if (doc.data().AttendeeId == row1.AttendeeId && speakerAttendeeList.includes(row1.AttendeeId) == false && hostAttendeeList.includes(row1.AttendeeId) == false) {
                   row1.Status = "Joined";
                   row1.JoinTime = doc.data().JoinTime;
                   row1.LeaveTime = doc.data().LeaveTime;
                }
                }
            });
          });
          this.allAttendeeList.map((row1) => {
          if([...new Set(allParticipantsList)].includes(row1.AttendeeId) == false){
            if(hostAttendeeList.includes(row1.AttendeeId) == true){
              row1.Type = "Host";
            }else if(speakerAttendeeList.includes(row1.AttendeeId) == true && hostAttendeeList.includes(row1.AttendeeId) == false){
                row1.Type = "Speaker";
            }
          }
          });
          this.allMembersList = this.allAttendeeList;
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },

    getFormattedDate: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var year = dt.getFullYear();
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var formattedValue =
        monthNames[month] + " " + day.toString() + ", " + year;
      return formattedValue;
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var seconds = dt.getSeconds();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue =
        hours.toString() +
        ":" +
        minutes.toString() +
        ":" +
        seconds.toString() +
        " " +
        amPM;
      return formattedValue;
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          this.allAttendeeList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL,
          });
        }
      });
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        //this.popupActiveExport = true;
        var datarow = [];
        var timeZone = [];

        timeZone.push("Report Exported In ")
      var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"'+ timezone + ' Time Zone' + '"');

        datarow.push("Name");
        datarow.push("Type");
        datarow.push("Company");
        datarow.push("Title");
        datarow.push("Status");
        datarow.push("Joined Time");
        datarow.push("Leave Time");

        var AttendeeData = [];
        AttendeeData.push(datarow);
        var TimeZoneHeader = [];
		    TimeZoneHeader.push(timeZone)

        selectedRows.map((row) => {
          //---------------------------------------------------------
          if (row.JoinTime != null) {
            var JoinDateTimeFormated = vm.SetTimeByZone(
                  new Date(row.JoinTime.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
          }
          if (row.LeaveTime != null) {
            var LeaveDateTimeFormated =  vm.SetTimeByZone(
                  new Date(row.LeaveTime.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
          }

          datarow = [];

          var Name = row.Name == undefined ? "" : row.Name;
          datarow.push(Name);
          var Type = row.Type == undefined ? "Attendee" : row.Type;
          datarow.push(Type);
          var Company = row.Company == undefined ? "" : row.Company;
          datarow.push(Company);
          var Title =
            row.Designation == undefined ? "" : '"' + row.Designation + '"';
          datarow.push(Title);
          var Status = row.Status == undefined ? "Not Joined" : "Joined";
          datarow.push(Status);
          var JoinedTime =
            JoinDateTimeFormated == undefined
              ? ""
              : '"' + JoinDateTimeFormated + '"';
          datarow.push(JoinedTime);
          var LeaveTime =
            LeaveDateTimeFormated == undefined
              ? ""
              : '"' + LeaveDateTimeFormated + '"';
          datarow.push(LeaveTime);

          AttendeeData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function(rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
        });
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = this.SessionName + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one roundtable to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
  },
  mounted() {
    //vm = this;
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    if (this.$route.params.sessionId == undefined) {
      this.$router.push({ name: "sessions" }).catch(() => {});
    } else {
      if (!moduleAttendeeManagement.isRegistered) {
        this.$store.registerModule(
          "attendeeManagement",
          moduleAttendeeManagement
        );
        moduleAttendeeManagement.isRegistered = true;
      }
     vm.sessionName = this.$route.params.sessionName;
    this.getAttendees();
    this.fetchParticipantsBySessionId(this.$route.params.sessionId);
    }

  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>